import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';

@Injectable({
    providedIn: 'root'
})
export class AtividadeGrupoDBService extends DatabaseService {
    override classname = 'AtividadeGrupoDBService';
    override table = 'atividade_grupo';

    protected override migration = 1;

    override indices = [
        {name: 'by_id', field: 'id', unique: false, multiEntry: false},
        {name: 'by_cliente', field: 'cliente_id', unique: false, multiEntry: false},
        {name: 'by_descricao', field: 'descricao', unique: false, multiEntry: false},
        {name: 'by_sinc', field: 'sinc', unique: false, multiEntry: false},
    ];
}
